import { getFileBlob } from "utils"
const moment = require("moment-timezone")

export const mapInitialValues = (
  selectedEvent,
  selectedEventCategories,
  formValues
) => {
  return {
    ...formValues,
    setup: {
      name: selectedEvent?.name,
      businessUnit: selectedEvent?.business_unit_id,
      layout: selectedEvent?.design?.template_id?.toString(),
      menuColor: selectedEvent?.design?.menu_bg_color,
      textColor: selectedEvent?.design?.menu_font_color,
      font: selectedEvent?.design?.menu_font_family,
      bgColor: selectedEvent?.design?.header_bg_color,
      category: selectedEventCategories,
      phone: selectedEvent?.phone,
      address: {
        address: selectedEvent?.address,
        lat: selectedEvent?.lat,
        lng: selectedEvent?.lon,
      },
      hideName: selectedEvent?.hidden_name,
      bgAnimation: !selectedEvent?.design?.bg_animation
        ? "0"
        : selectedEvent?.design?.bg_animation,
      ...(selectedEvent?.design?.bg_image === "custom"
        ? {
            bgImage: {
              editedImage: selectedEvent?.design?.bg_image_url,
            },
            bgImageType: "2",
          }
        : { bgImageType: "1" }),
      ...(selectedEvent?.design?.event_thumbnail === "custom"
        ? {
            thumbnailImage: {
              editedImage: selectedEvent?.design?.event_thumbnail_url,
            },
            thumbnailImageType: "2",
          }
        : { thumbnailImageType: "1" }),
    },
  }
}

export const mapNewExpValuesToApi = (setupValues, userId, vendorId) => {
  return {
    experience: {
      business_unit_id: setupValues?.businessUnit
        ? setupValues?.businessUnit
        : null,
      name: setupValues.name,
      published: false,
      timezone: moment.tz.guess(),
      user_id: userId,
      vendor_id: vendorId,
      phone: setupValues?.phone,
      address: setupValues?.address ? setupValues?.address?.address : null,
      lat: setupValues?.address ? setupValues?.address?.lat : null,
      lon: setupValues?.address ? setupValues?.address?.lng : null,
      hidden_name: setupValues?.hideName || false,
    },
  }
}

export const mapUpdatedExpValuesToApi = (
  selectedEvent,
  setupValues,
  bgImageIsDirty,
  thumbnailIsDirty,
  userId,
  vendorId
) => {
  return {
    experience: {
      ...selectedEvent,
      access_type: selectedEvent?.access_type || 3,
      business_unit_id: setupValues?.businessUnit
        ? setupValues?.businessUnit
        : selectedEvent.business_unit_id,
      name: setupValues.name,
      phone: setupValues?.phone,
      address: setupValues?.address ? setupValues?.address?.address : null,
      lat: setupValues?.address ? setupValues?.address?.lat : null,
      lon: setupValues?.address ? setupValues?.address?.lng : null,
      hidden_name: setupValues?.hideName || false,
    },
    design: {
      ...selectedEvent?.design,
      template_id: setupValues.layout,
      menu_bg_color: setupValues.menuColor,
      menu_font_color: setupValues.textColor,
      menu_font_family: setupValues.font,
      header_bg_color: setupValues.bgColor,
    },
    background: {
      ...(bgImageIsDirty
        ? {
            files: setupValues?.bgImage?.editedImage
              ? [getFileBlob(setupValues?.bgImage?.editedImage)]
              : null,
            vendor_id: vendorId,
            user_id: userId,
            dir: "background",
          }
        : {}),
    },
    thumbnail: {
      ...(thumbnailIsDirty
        ? {
            files: setupValues?.thumbnailImage?.editedImage
              ? [getFileBlob(setupValues?.thumbnailImage?.editedImage)]
              : null,
            vendor_id: vendorId,
            user_id: userId,
            dir: "background",
          }
        : {}),
    },
  }
}
